import React from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import * as moment from "moment";
import "moment/locale/zh-cn";
import "./App.css";

import UsmsSendStats from "./page/usms/SendStats";
import UsmsCompanyStatistic from "./page/usms/SendStats/CompanyStatistic";
import StatisticDetail from "./page/usms/SendStats/StatisticDetail";
import StatisticPackage from './page/usms/SendStats/StatisticPackage';

import UsmsSignatures from "./page/usms/Signatures";
import SignatureDetail from "./page/usms/Signatures/Detail";
import UsmsTemplates from "./page/usms/Templates";
import TemplateDetail from "./page/usms/Templates/Detail";
import UsmsDashboard from "./page/usms/Dashboard";
import UsmsLogin from "./page/usms/login";
import SendMessage from "./page/usms/SendMessage";
import SendRecords from "./page/usms/SendRecords";
import SendDetail from "./page/usms/SendRecords/Detail";
import Channel from "./page/usms/Channel";
import ChannelView from "./page/usms/ChannelView";
import CompanyList from './page/usms/UserManage';
import UserProductConfig from "./page/usms/UserProductConfig";
import CustomerDetailConfig from "./page/usms/UserProductConfig/CustomerDetailConfig";

import EmailTemplates from "./page/email/Templates";
import EmailTemplateDetail from "./page/email/Templates/Detail";

import Login from "./page/login";
import AddFreeAmount from "./page/usms/UserManage/AddFreeAmount";
import AddTrade from "./page/usms/UserManage/AddTrade";
import Upgrade from "./page/usms/UserManage/Upgrade";
import Credit from "./page/usms/UserManage/AmountCredit";
import AgentList from "./page/usms/Agent/List";
import AgentUserList from "./page/usms/Agent/UserList";
import AddAgentUser from "./page/usms/Agent/AddUser";
import AgentWalletList from "./page/usms/Agent/wallet";

moment.locale("zh-cn");

class App extends React.PureComponent {
  render() {
    return (
      <div className="page" key={this.props.location.key}>
        <Switch>
          <Route exact path="/login" component={Login} />
          <Route exact path="/usmslogin" component={UsmsLogin} />
          {/* 给客户经理单独开的链接，不过usms用户校验。固定地址/usms/manager/ */}
          <Route exact path="/usms/manager/sendstats" component={UsmsSendStats} />
          <Route exact path="/usms/manager/statisticdetail" component={StatisticDetail} />
          <Route exact path="/usms/manager/statisticpackage" component={StatisticPackage} />
          {/* 统一过usms用户校验。固定地址/usms/*/}
          <Route exact path="/usms/statisticpackage" component={StatisticPackage} />
          <Route exact path="/usms/signatures" component={UsmsSignatures} />
          <Route exact path="/usms/signaturedetail" component={SignatureDetail} />
          <Route exact path="/usms/templates" component={UsmsTemplates} />
          <Route exact path="/usms/templatedetail" component={TemplateDetail} />
          <Route exact path="/usms/dashboard" component={UsmsDashboard} />
          <Route exact path="/usms/sendmessage" component={SendMessage} />
          <Route exact path="/usms/sendrecords" component={SendRecords} />
          <Route exact path="/usms/senddetail" component={SendDetail} />
          <Route exact path="/usms/channel" component={Channel} />
          <Route exact path="/usms/channelview" component={ChannelView} />
          <Route exact path="/usms/companylist" component={CompanyList} />
          <Route exact path="/usms/addfree" component={AddFreeAmount} />
          <Route exact path="/usms/cancelfree" component={AddFreeAmount} />
          <Route exact path="/usms/addtrade" component={AddTrade} />
          <Route exact path="/usms/upgrade" component={Upgrade} />
          <Route exact path="/usms/credit" component={Credit} />
          {/* 邮件 */}
          <Route exact path="/usms/email/templates" component={EmailTemplates} />
          <Route exact path="/usms/email/templatedetail" component={EmailTemplateDetail} />
          {/* 配置折扣 */}
          <Route exact path="/usms/customers" component={UserProductConfig} />
          <Route exact path="/usms/customerdetail" component={CustomerDetailConfig} />
          {/* 用户发送统计详情 */}
          <Route exact path="/usms/companysendstats" component={UsmsCompanyStatistic} />
          {/* 代理商列表 */}
          <Route exact path="/usms/agentlist" component={AgentList} />
          {/* 代理商关联的用户列表 */}
          <Route exact path="/usms/agentUserlist" component={AgentUserList} />
          {/* 关联代理用户 */}
          <Route exact path="/usms/addAgentUser" component={AddAgentUser} />
           {/* 代理商钱包充值 */}
          <Route exact path="/usms/wallet/transaction" component={AgentWalletList} />
        </Switch>
      </div>
    );
  }
}

export default withRouter(App)